// 本地兜底翻译；线上翻译走 CDN（MTS），需在 MTS 后台补齐 Fund.WireCurrencyNotSupported
export const Fund = {
    WireCurrencyNotSupported: '该收款账户币种暂不支持出金，请更换账户或新增币种为 USD、GBP、EUR 的电汇账户',
};
